import { useProethicaCommandBarActions } from "@features/dashboard/hooks/useProethicaCommandBarActions";
import { useRegisterActions } from "@memorang/command-bar";

export const ModuleCommandBarActions = () => {
	const actions = useProethicaCommandBarActions();
	useRegisterActions(actions);
	return null;
};
